import { render, staticRenderFns } from "./ModalX2.vue?vue&type=template&id=aa71c548&"
import script from "./ModalX2.vue?vue&type=script&lang=js&"
export * from "./ModalX2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports